import { state } from '../state.ts';

/**
 * Compute the left/right CSS percentages for the highlighted [start, end] marked
 * range so it can be overlaid on the timeline slider track.
 */
export function markRangePercent(): { left: number; width: number } {
  if (state.totalFrames <= 0) return { left: 0, width: 0 };
  const left = (state.startFrame / state.totalFrames) * 100;
  const right = (state.endFrame / state.totalFrames) * 100;
  return { left, width: Math.max(0, right - left) };
}
